/**
 * Created by Christof Sander on 18.01.2017.
 */

const utils = require('../../lib/utils');
var store = require('../../lib/store');
var appConfig = require('../../lib/config').getConfig();

module.exports = {
	config: {
		environment: {}
	},
	model: {
		environment: {},
		$body: null,

		cssSources: [],
		jsSources: [],

		timeouts: {
			refreshEnv: null,
			refreshEnvServer: null
		}
	},
	events: {
		/**
		 * this function handles the global control key register
		 */
		controlShortCutsDown: {
			type: 'keydown',
			action: function(event){
				utils.keyboard.down(
					utils.keyboard.getKeyCode(event)
				);
			}
		},

		/**
		 * this function handles the global control key register
		 */
		controlShortCutsUp: {
			type: 'keyup',
			action: function(event){
				utils.keyboard.up(
					utils.keyboard.getKeyCode(event)
				);
			}
		}
	},
	methods: {
		/**
		 * this function is used to change the actual loaded page properties according to the given routes' model.
		 * this affects things like the pageTitle or keywords and so on.
		 *
		 * @param routeModel
		 */
		changeRouteProperties: function(routeModel){
			routeModel.meta = routeModel.meta || {};
			var title       = routeModel.meta.title || routeModel.name || routeModel.nameSEO;
			var keywords    = routeModel.meta.keywords || '';
			var description = routeModel.meta.description || '';
			if(title){
				if(this.model.$title.length > 0)        this.model.$title.html(title);
				if(this.model.$metaTitle.length > 0)    this.model.$metaTitle.attr('content', title);
			}
			if(this.model.$metaKeywords.length > 0)     this.model.$metaKeywords.attr('content', keywords);
			if(this.model.$metaDescription.length > 0)  this.model.$metaDescription.attr('content', description);
		},

		/**
		 * this function will be invoked when an environmental change has been performed and is used to propagate the
		 * new environment to all interested components.
		 *
		 * @param initialExecution              boolean - is this the very first execution
		 * @param storage                       {} - actual storage
		 * @param styles                        [] - available styles (e.g., mobile, desktop, ...)
		 * @param serverKnownEnvironment        {} - this flag contains the environment which was available to the server during the server-side render call.
		 * @param newEnvironment                {} - this flag contains the new environmental data
		 * @param externalDrivenCall            boolean - has this refresh been invoked by external events (like resize or orientation change, ...)
		 */
		onEnvironmentChanged: function(initialExecution, storage, styles, serverKnownEnvironment, newEnvironment, externalDrivenCall){
			// save environment within this component
			this.model.environment = newEnvironment;

			// set style classes in DOM if necessary
			if(styles){
				this.model.$body.removeClass(styles.join(' ')).addClass(newEnvironment.style);
			}

			// set device and breakPoint-classes in DOM if possible
			if(storage.app && storage.app.service && storage.app.service.config && storage.app.service.config.media && storage.app.service.config.media.layout){
				var devices = Object.keys(storage.app.service.config.media.layout);
				var breakPoints = [];

				// check if first found level are breakPoints
				if(devices[0].length <= 2){
					breakPoints = devices;
					devices = [];
				}
				else {
					breakPoints = {};
					for(var d in devices){
						breakPoints = utils.merge(breakPoints, storage.app.service.config.media.layout[devices[d]]);
					}
					breakPoints = Object.keys(breakPoints);
				}

				if(devices.length > 0){
					this.model.$body.removeClass('device-' + devices.join(' device-')).addClass('device-' + newEnvironment.device.type);
				}
				if(breakPoints.length > 0){
					this.model.$body.removeClass('breakPoint-' + breakPoints.join(' breakPoint-')).addClass('breakPoint-' + newEnvironment.breakPoint);
				}
			}

			// TODO: limit this console.log() to admins only
			//console.log('ENVIRONMENT', newEnvironment);

			// refresh environment dependent components
			window.componentTree.onEnvironmentChange(storage, initialExecution, serverKnownEnvironment, externalDrivenCall);
		},

		/**
		 * this function will be called each time the attach trigger will be executed and is used to be able to extend
		 * this component while being able to overwrite the attach trigger but keep the attach base functionality.
		 */
		onAttachDone: function(){
			this.config.environment.isTouchable = !!("ontouchstart" in window || navigator.msMaxTouchPoints);
			this.model.$body            = this.$.find('body');
			this.model.$head            = this.$.find('head');
			this.model.$title           = this.model.$head.find('> title');
			this.model.$metaTitle       = this.model.$head.find('> meta[name="title"]');
			this.model.$metaDescription = this.model.$head.find('> meta[name="description"]');
			this.model.$metaKeywords    = this.model.$head.find('> meta[name="keywords"]');

			var self = this;

			// TODO: don't pollute the console
			//console.log('######################## DOM READY FOR WORK ########################');

			utils.refreshEnvironment(true, true, store, store.get(), self.onEnvironmentChanged, self, self.config.environment, undefined, (Math.abs((window.orientation === undefined ? 90 : window.orientation) % 180) == 90));
			$(window).on('resize orientationchange', function(event){
				// refresh dimensions
				utils.refreshEnvironment(false, true, store, store.get(), self.onEnvironmentChanged, self, self.config.environment, undefined, (Math.abs((window.orientation === undefined ? 90 : window.orientation) % 180) == 90));
			});

			this.callHandler('DOMReady');

			window.componentTree.focusRightComponent();

			this.trackingPolicyChanged();

			this.debugComponentIndexProblem();
		},



	/////////////////////////////////////
	/// ANALYSIS STUFF
	/////////////////////////////////////

		/**
		 * this function is used to define the window.track function according to the given policy status.
		 * NOTE: it may call the loadTracking() method.
		 * NOTE: it resets the window.track method in case of acceptTracking will be denied after it has been granted previously.
		 */
		trackingPolicyChanged: function(){
			//console.log('session data', storage, storage.session, 'CONFIG', appConfig.store.cookie);
			if(
				((storage.session.data || {}).cookiePolicy || {}).acceptTracking === true
				||
				(
					appConfig.store.cookie.policy.acceptTrackingByDefault
					&&
					((storage.session.data || {}).cookiePolicy || {}).acceptTracking === null
				)
			){
				if(!window.trackingGranted) {
					this.loadTracking()
				}
			}
			else {
				delete window.trackingGranted;
			}
		},

		/**
		 * this function is used to load external tracking tools if necessary.
		 * NOTE: it may be overwritten in case of special needs by the master.js in charge.
		 */
		loadTracking: function(){
			if(window.trackingGranted) return;

			// Google Analytics
			if(((((storage.app.service || {}).config || {}).analysis || {}).google || {}).id){
				(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
					(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
					m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
				})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
				ga('create', storage.app.service.config.analysis.google.id, 'auto');
				ga('send', 'pageview');
				window.trackingGranted = true;
			}
		},



		// TODO: DEBUG
		debugComponentIndexProblem: function(){
			// setTimeout(function(self){
			// 	var problemComponents = {};
			//
			// 	// TODO: DEBUG CLEANUP: check all components in lookup if their parents exists in lookup or not
			// 	utils.forEach(window.componentTree.lookup, function(component, componentIndex){
			// 		if(component.parentComponentIndex && !window.componentTree.lookup[component.parentComponentIndex]){
			// 			problemComponents[componentIndex] = component;
			// 			console.error('COMPONENT MISSING @ ', componentIndex, component.componentClass, component.inclusionActionSourceComponentIndex || '-', component.inclusionKey || '-', ' => ', component.parentComponentIndex);
			// 		}
			// 	});
			//
			// 	if(utils.collectionSize(problemComponents) > 0){
			// 		console.error('DEBUGGING PROBLEM - MISSING PARENT');
			// 	}
			// 	self.debugComponentIndexProblem();
			// }, 1000, this);
		},

		/**
		 * checks if this webpage has been loaded within an iframe
		 *
		 * @returns {boolean}
		 */
		inIframe: function() {
			try {
				return window.self !== window.top;
			} catch (e) {
				return true;
			}
		}
	},
	hooks: {
		attach: function($element, options){
			this.onAttachDone();
		}
	}
};